import React, { useState } from 'react';
import {setCallRead} from '../../api';
import { useNavigate } from 'react-router-dom';
import { showError, ucwords } from '../../utils';

import CallBtns from './CallBtns';
import { ReactComponent as IconRead } from '../../assets/icons/read.svg';
import { ReactComponent as IconUnread } from '../../assets/icons/unread.svg';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
import {TagColor} from "../layout/TagColor";
import useAlert from '../../hooks/useAlert';


// Righe di chiamate raggruppate con espansione dettagli
const CallListRow = ({ itemGroup, setRawList }) => {
    const { id, numero, chiamante_id, chiamante_title, parlato_con, read, count, lastCallTime, tag, blocco, priorita, isCallDetails} = itemGroup;
    const [expanded, setExpanded] = useState(false);
    const [readLoading, setReadLoading] = useState({});
    const navigate = useNavigate();
    const alert = useAlert();

    const handleReadClick = async () => {
        try {
            setReadLoading({...readLoading, [id]: true});
            await setCallRead(id, !read);
            // aggiorna lo stato nel componente genitore se necessario        
            setRawList(prev => {
                let newList = [...prev];
                const index = newList.findIndex(call => call.id === id);
                if (index !== -1) {
                    newList[index] = {...newList[index], read: !read};
                }
                return newList;
            });
        } catch (e) {
            showError([e.message]);
        } finally {
            setReadLoading({...readLoading, [id]: false});
        }
    };
    const handleContactClick = () => setExpanded(prev => !prev);

    
    let chiamante_title_lower = ucwords(chiamante_title);
    let parlato_con_lower = ucwords(parlato_con);

    return (
        <div className={`vista-row vista-${read ? 'read' : 'unread'}`} data-numero={numero}>
            <div className="vista-row-info">
                <div className="sx">
                    <button className="icon call-read-status" onClick={count === 1 ? handleReadClick : handleContactClick} disabled={readLoading[id]} aria-label={read ? 'Segna non letto' : 'Segna letto'}>
                        {readLoading[id] ? <IconLoading className="icon-loading"/> : (read ? <IconRead /> : <IconUnread />)}
                    </button>
                    {count > 1 && <span className="icon vista-count">{count}</span>}
                    <div className="item" onClick={handleContactClick}>
                        <span className="title text-trunc-ellipsis">{chiamante_title_lower}</span>
                        <span className="subtitle text-trunc-ellipsis">{parlato_con_lower}</span>
                    </div>
                </div>
                <div className="dx">
                    <span className="vista-time">{lastCallTime}</span>
                    {! isCallDetails && <TagColor id={id} className="vista-tag">{tag}</TagColor>}
                </div>
            </div>
            <div className="vista-row-actions">
                {expanded && !isCallDetails && <CallBtns itemGroup={itemGroup} setRawList={setRawList} />}
            </div>
        </div>
    );
}

export default CallListRow;